import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import landing from "@/content/landing";

export default function PublicFooter() {
  const t = landing.footer;
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200/70 bg-gradient-to-b from-ag-paper to-white" data-testid="landing-footer">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between lg:gap-16">
          <div className="max-w-md">
            <Logo variant="full" tone="light" className="h-14 w-auto" />
            <div className="mt-6 flex items-center gap-4">
              <div className="h-px w-10 bg-amber-500/70" aria-hidden="true" />
              <p className="font-serif text-lg italic leading-snug text-slate-600 sm:text-xl">
                {t.claim}
              </p>
            </div>
          </div>

          <nav aria-label="Footer-Navigation" className="flex flex-col gap-4 text-sm text-slate-600 sm:flex-row sm:flex-wrap sm:gap-8 lg:justify-end">
            {t.links.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="transition hover:text-ag-ink"
                data-testid={`landing-footer-link-${link.href.replace(/\W+/g, "-").replace(/^-|-$/g, "")}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="ag-hairline mt-12" aria-hidden="true" />
        <div className="mt-6 text-xs uppercase tracking-[0.22em] text-slate-400">
          {t.copyright} · {year}
        </div>
      </div>
    </footer>
  );
}
